import { useParams } from 'react-router-dom';

import { useAppSelector } from '../../../../../../store/hooks';
import { getIsAppLoadingSelector } from '../../../../../shared/store/selectors/get-is-app-loading/get-is-app-loading.selector';
import { ReleaseModel } from '../../../../models/release.model';
import { getAppReleasesSelector } from '../../../../store/selectors/get-app-releases/get-app-releases.selector';
import { ReleasesTableHookConfigModel } from './models/releases-table-hook-config.model';

export const useGetReleasesTableConfigHook =
  (): ReleasesTableHookConfigModel => {
    const { id: appId } = useParams();
    const isLoading = useAppSelector(getIsAppLoadingSelector);
    const tableRows: ReleaseModel[] = useAppSelector(getAppReleasesSelector);
    const count = useAppSelector(
      state => state.appsFeature.releases.pagination.totalCount
    );
    const rowsPerPage = useAppSelector(
      state => state.appsFeature.releases.pagination.size
    );
    const page = useAppSelector(
      state => state.appsFeature.releases.pagination.pageNumber
    );

    return {
      appId,
      tableRows,
      isLoading,
      count,
      rowsPerPage,
      page,
    };
  };
